import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'components/common/button';
import ServiceDetail from 'modules/page/landing/ServiceDetail';
import { cryptojs } from 'helpers';
import moment from 'moment';
import IconConfigWithTheme from 'components/common/icon-config-with-theme';
import useAuth from 'hooks/useAuth';
import type { DataEncodeURLProps } from 'type.global';
import ServiceSymstom from 'modules/page/landing/ServiceSymstom';
import ServiceMethod from 'modules/page/landing/ServiceMethod';
import ServicePharmacyNearby from 'modules/page/landing/ServicePharmacyNearby';
import ServiceRating from 'modules/page/landing/ServiceRating';
import ServiceQeustionAndAnswer, { QeustionBox } from 'modules/page/landing/ServiceQnA';
import ServiceRelate from 'modules/page/landing/ServiceRelate';
import LandingLogin from 'modules/page/landing/LandingLogin';
import MetaTags from 'react-meta-tags';

function MTHServiceLanding() {
    const navigate = useNavigate();
    const { auth } = useAuth();
    const timer = useRef<NodeJS.Timeout>();
    const [showMethod, setShowMethod] = useState(1);

    const params = useMemo(() => {
        const origin = window.location.origin;
        return origin.includes('fastcare.co') ? '?voucher=fastcare01' : '';
    }, [window.location.origin]);

    const onNextPage = () => {
        let path = process.env.REACT_APP_LIFF_REDIRECT_DEFAULT;
        let defaultPath = '/mth/claim';

        let dataForEncode: DataEncodeURLProps = {
            path: defaultPath,
            params: window.location.search || '?fromService=true',
            data: {
                authorization: null,
                userId: null,
                autoLogin: 0,
            },
        };
        if (window.location.origin.includes('fastcare.co')) {
            path = process.env.REACT_APP_LIFF_REDIRECT_FASTCARE;
            dataForEncode = {
                ...dataForEncode,
                params: window.location.search || '?voucher=fastcare01&fromService=true',
                data: {
                    authorization: null,
                    userId: null,
                    autoLogin: 0,
                    partner: '18',
                },
            };
        }
        const encode = cryptojs.encode(dataForEncode);
        if (auth.isAuth) {
            return navigate(dataForEncode.path + dataForEncode.params);
        }
        return window.location.assign(path + '?to=' + encode);
    };

    const onChangeMethod = (method: number) => {
        let _method = method;

        clearInterval(timer.current);
        setShowMethod(_method);

        timer.current = setInterval(() => {
            _method++;

            if (_method < 4) {
                setShowMethod(_method);
            } else {
                setShowMethod(1);
                _method = 1;
            }
        }, 5000);
    };

    useEffect(() => {
        onChangeMethod(1);

        return () => clearInterval(timer.current);
    }, []);

    return (
        <>
            <MetaTags>
                <link rel='canonical' href={window.location.href} />
            </MetaTags>
            <ServiceDetail primaryBgc='#00B1AD' secondBgc='#f9f9fa' twoButton={true}>
                <div className='landing-service'>
                    <div className='service-panel service-content pb-0'>
                        <div className='title'>บริการ</div>
                        <h1 className='sub-title'>ปรึกษาจิตแพทย์/นักจิตวิทยาคลินิก</h1>
                        <h4 className='detail'>
                            <div>ปรึกษาแพทย์ผู้เชี่ยวชาญเฉพาะทาง </div>
                        </h4>
                        <div className='sub-detail'>
                            <div>มีความเครียด ไม่สบายใจ กระทบชีวิตประจำวัน ต้องการให้แพทย์ พิจารณาจ่ายยา โปรดเลือกปรึกษาจิตแพทย์</div>
                            {/* <div>พิจารณาจ่ายยา โปรดเลือกปรึกษาจิตแพทย์</div> */}
                        </div>
                        <div className='service-image mb-3'>
                            <img src='/images/service-landing/service-mth-desktop.png' className='desktop' alt='desktop' />
                            <img src='/images/service-landing/service-mth-mobile.png' className='mobile' alt='mobile' />
                        </div>
                    </div>
                    <div className='service-panel service-detail'>
                        <h3 className='title'>รายละเอียดบริการ</h3>
                        <div className='detail'>
                            <div className='icon'>
                                <IconConfigWithTheme pageName='landing1_tlm' iconName='sevice_detail_time' />
                            </div>
                            <h4>จิตแพทย์ อังคาร พุธ พฤหัสบดี 16.00-20.00 น. เสาร์ 13.00-17.00 น.</h4>
                        </div>
                        <div className='detail'>
                            <div className='icon'>
                                <IconConfigWithTheme pageName='landing1_tlm' iconName='sevice_detail_time' />
                            </div>
                            <h4>นักจิตวิทยาคลินิก ทุกวัน จันทร์-ศุกร์ 16.00-20.00 น., เสาร์-อาทิตย์ 13.00-17.00 น. </h4>
                        </div>
                        <div className='detail'>
                            <div className='icon'>
                                <IconConfigWithTheme pageName='landing1_tlm' iconName='sevice_detail' />
                            </div>
                            <h4>หากปรึกษาจิตแพทย์ แพทย์อาจพิจารณาสั่งยา พร้อมส่งยาถึงบ้าน</h4>
                        </div>
                        <div className='detail'>
                            <div className='icon'>
                                <IconConfigWithTheme pageName='landing1_tlm' iconName='dalivery_time' />
                            </div>
                            <h4>ระยะเวลาจัดส่งประมาณ 2-3 วัน</h4>
                        </div>
                        <h3 className='title'>อัตราค่าบริการ</h3>
                        <div className='sevice-rate-panel'>
                            <div className='sevice-rate'>
                                <div className='list full-row'>
                                    <div className='list-icon'>
                                        <IconConfigWithTheme pageName='landing1_tlm' iconName='sevice_rate' />
                                    </div>
                                    <div className='list-content'>
                                        <div className='list-title'>ค่าแพทย์</div>
                                        <h4 className='list-detail'>
                                            <span>
                                                จิตแพทย์: เริ่มต้นที่ 1200 บาท/ 30 นาที <br />
                                                นักจิตบำบัด: เริ่มต้นที่ 900 บาท/ 30 นาที
                                            </span>
                                        </h4>
                                    </div>
                                </div>
                                <div className='list'>
                                    <div className='list-icon'>
                                        <IconConfigWithTheme pageName='landing1_tlm' iconName='medicine_rate' />
                                    </div>
                                    <div className='list-content'>
                                        <div className='list-title'>ค่ายา (ถ้ามี)</div>
                                        <h4 className='list-detail'>
                                            <span>ราคาตามหน้าร้านยา/คลินิก</span>
                                        </h4>
                                    </div>
                                </div>
                                <div className='list'>
                                    <div className='list-icon'>
                                        <IconConfigWithTheme pageName='landing1_tlm' iconName='dalivery_rate' />
                                    </div>
                                    <div className='list-content'>
                                        <h3 className='list-title'>ค่าจัดส่ง</h3>
                                        <h4 className='list-detail'>
                                            <div>ไม่เกิน 65 บาท</div>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div className='panel-footer'>
                                <Button
                                    data-test-id='consultNow'
                                    style={{ backgroundColor: '#4472C4', color: 'var(--white)' }}
                                    onClick={() => onNextPage()}
                                >
                                    เริ่มปรึกษา
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='consult-now'>
                    <div className='custom-btn'>
                        <Button
                            data-test-id='consultNow'
                            style={{ backgroundColor: '#4472C4', color: 'var(--white)' }}
                            onClick={() => onNextPage()}
                        >
                            เริ่มปรึกษา
                        </Button>
                    </div>
                </div>
            </ServiceDetail>
            <ServiceSymstom primaryBgc='#e5eef9' secondBgc='#f9f9fa' imageBgc='blue'>
                <div className='landing-panel'>
                    <div className='landing-icon'>
                        <img src='/images/service-landing/pharmcare-short-logo.svg' alt='pharmcare-icon' />
                    </div>
                    <h2>
                        <div className='title'>ลักษณะอาการ</div>
                        <div className='sub-title'>ที่แพทย์ของเราให้คำปรึกษา</div>
                    </h2>
                    <div className='landing-content'>
                        <div className='landing-image'>
                            <img src='/images/service-landing/symptoms-tlm.webp' alt='symptoms' />
                        </div>
                        <div className='symptoms'>
                            <div className='symptoms-about'>ตัวอย่างอาการ...</div>
                            <ul className='symptoms-list'>
                                <li>
                                    <h4>นอนไม่หลับ</h4>
                                </li>
                                <li>
                                    <h4>เศร้า ไม่มีความสุข</h4>
                                </li>
                                <li>
                                    <h4>เครียด</h4>
                                </li>
                                <li>
                                    <h4>ไม่อยากทำอะไรเลย</h4>
                                </li>
                                <li>
                                    <h4>ท้อแท้</h4>
                                </li>
                                <li>
                                    <h4>ไม่อยากมีชีวิต</h4>
                                </li>
                                <li>
                                    <h4>อารมณ์แปรปรวน</h4>
                                </li>
                                <li>
                                    <h4>ย้ำคิดย้ำทำ</h4>
                                </li>
                                <li>
                                    <h4>มีปัญหาชีวิต ต้องการที่ปรึกษา</h4>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </ServiceSymstom>
            <ServiceMethod secondBgc='#f9f9fa'>
                <div className='landing-panel'>
                    <h3 className='title'>ขั้นตอนในการรับบริการ</h3>
                    <div className='method'>
                        <div className='method-row mark-1'>
                            <div className='method-row mark-2'>
                                <div className='method-col'>
                                    <div
                                        className={showMethod === 1 ? 'method-title active' : 'method-title'}
                                        onClick={() => onChangeMethod(1)}
                                    >
                                        <div className='circle'>1</div>
                                        <h3>คุยกับเแพทย์</h3>
                                    </div>
                                </div>
                                <div className='method-col'>
                                    <div
                                        className={showMethod === 2 ? 'method-title active' : 'method-title'}
                                        onClick={() => onChangeMethod(2)}
                                    >
                                        <div className='circle'>2</div>
                                        <h3>รอใบสั่งยา</h3>
                                    </div>
                                </div>
                                <div className='method-col'>
                                    <div
                                        className={showMethod === 3 ? 'method-title active' : 'method-title'}
                                        onClick={() => onChangeMethod(3)}
                                    >
                                        <div className='circle'>3</div>
                                        <h3>รอรับยา</h3>
                                    </div>
                                </div>
                            </div>
                            <div className='method-row mark-3 line-center'>
                                <div className={showMethod === 1 ? 'method-col active' : 'method-col'}>
                                    <div className='method-image'>
                                        <img src='/images/service-landing/method-tlm-1.jpg' title='คุยกับเแพทย์' alt='คุยกับเแพทย์' />
                                    </div>
                                </div>
                                <div className={showMethod === 2 ? 'method-col active' : 'method-col'}>
                                    <div className='method-image'>
                                        <img src='/images/service-landing/method-tlm-2.jpg' title='รอใบสั่งยา' alt='รอใบสั่งยา' />
                                    </div>
                                </div>
                                <div className={showMethod === 3 ? 'method-col active' : 'method-col'}>
                                    <div className='method-image'>
                                        <img src='/images/service-landing/method-3.jpg' title='รอรับยา' alt='รอรับยา' />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='method-row'>
                            <div className={showMethod === 1 ? 'method-col active' : 'method-col'}>
                                <div className='method-detail'>
                                    <div className='method-title'>
                                        <div>1. ปรึกษาแพทย์</div>
                                    </div>
                                    <p>กรอกข้อมูลสุขภาพ อาการของคุณ และเริ่มต้นสนทนากับแพทย์ ภายใน 5 นาที</p>
                                </div>
                            </div>
                            <div className={showMethod === 2 ? 'method-col active' : 'method-col'}>
                                <div className='method-detail'>
                                    <div className='method-title'>
                                        <div>2. รอใบสั่งยา</div>
                                    </div>
                                    <p>แพทย์จะเขียนใบสั่งยาให้ตามอาการเบื้องต้นของคุณ</p>
                                </div>
                            </div>
                            <div className={showMethod === 3 ? 'method-col active' : 'method-col'}>
                                <div className='method-detail'>
                                    <div className='method-title'>
                                        <div>3. รอรับยา</div>
                                    </div>
                                    <p>ยืนยันรายการ ที่อยู่จัดส่ง เพื่อรอรับยาพร้อมติดตามสถานะแบบเรียลไทม์</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ServiceMethod>
            <ServiceRating>
                <div>
                    <div className='rating-box'>
                        <div className='rating-comment'>
                            ได้คุยกับคุณหมอ ทำให้คลายความกังวลเกี่ยวกับอาการที่เป็นอยู่ไปมากเลยค่ะ
                            แถมช่วงนี้งานยุ่งยังไม่มีเวลาเดินทางไปโรงพยาบาล นี่สามารถคุยผ่านวีดีโอคอลปรึกษากับคุณหมอ สะดวกมาก ๆ เลยค่ะ
                        </div>
                        <div className='rating-score'>
                            <IconConfigWithTheme pageName='landing5_tlm' iconName='star' />

                            <span>5</span>
                        </div>
                        <div className='rating-footer'>
                            <div className='rating-name'>เจ</div>
                            <div className='rating-date'>15 Jan 2022</div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className='rating-box'>
                        <div className='rating-comment'>
                            งานก็ยุ่ง ไปรอที่โรงพยาบาลก็ต้องลางาน ใช้บริการของฟาร์มแคร์แค่จองเวลา พอถึงเวลานัดก็แค่ยกโทรศัพท์
                            สามารถปรึกษากับคุณหมอได้ทันที เป็นบริการที่ตอบโจทย์ในยุคนี้มากครับ
                        </div>
                        <div className='rating-score'>
                            <IconConfigWithTheme pageName='landing5_tlm' iconName='star' />

                            <span>5</span>
                        </div>
                        <div className='rating-footer'>
                            <div className='rating-name'>เกณิกา</div>
                            <div className='rating-date'>10 Mar 2022</div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className='rating-box'>
                        <div className='rating-comment'>
                            ชอบที่คุยกับหมอจบ ที่นี่มีบริการส่งยาจากร้านยาให้ถึงบ้าน รอแค่ไม่กี่ชั่วโมง ก็ได้รับยาแล้ว สะดวกมากครับ
                        </div>
                        <div className='rating-score'>
                            <IconConfigWithTheme pageName='landing5_tlm' iconName='star' />

                            <span>5</span>
                        </div>
                        <div className='rating-footer'>
                            <div className='rating-name'>ไมค์</div>
                            <div className='rating-date'>25 Jun 2022</div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className='rating-box'>
                        <div className='rating-comment'>
                            ช่วงโควิด แถมงานก็ยุ่ง ไม่อยากลางานเพื่อไปนั่งรอที่โรงพยาบาล มาเจอบริการปรึกษาแพทย์ของที่นี่ ตอบโจทย์มากค่ะ
                            อยากชวนให้มาลองใช้กันค่ะ
                        </div>
                        <div className='rating-score'>
                            <IconConfigWithTheme pageName='landing5_tlm' iconName='star' />

                            <span>5</span>
                        </div>
                        <div className='rating-footer'>
                            <div className='rating-name'>วิน</div>
                            <div className='rating-date'>18 Aug 2022</div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className='rating-box'>
                        <div className='rating-comment'>
                            วีดีโอคอลปรึกษาแพทย์ของฟาร์มแคร์ มีแพทย์เฉพาะทางให้เราสามารถเลือกได้ แถมสามารถจองเวลาที่เราสะดวกได้
                            คุณหมอก็น่ารัก เป็นกันเองมาก รู้สึกเหมือนไปพบที่โรงพยาบาลเลยค่ะ
                        </div>
                        <div className='rating-score'>
                            <IconConfigWithTheme pageName='landing5_tlm' iconName='star' />

                            <span>5</span>
                        </div>
                        <div className='rating-footer'>
                            <div className='rating-name'>นนท์</div>
                            <div className='rating-date'>23 Dec 2022</div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className='rating-box'>
                        <div className='rating-comment'>
                            ไม่ต้องกังวลกับอาการที่ผิดปกตินาน ๆ เพียงแค่จองเวลาพบแพทย์ รอเวลานัด ก็ได้คุยกับคุณหมอตัวจริง
                            แถมคุณหมอจ่ายยาให้ร้านยาส่งถึงบ้านให้ได้ด้วย สะดวกมากเลยครับ คิดว่าคงกลับมาใช้บริการอีกแน่ ๆ
                        </div>
                        <div className='rating-score'>
                            <IconConfigWithTheme pageName='landing5_tlm' iconName='star' />

                            <span>5</span>
                        </div>
                        <div className='rating-footer'>
                            <div className='rating-name'>สุธาวัลย์</div>
                            <div className='rating-date'>27 Dec 2020</div>
                        </div>
                    </div>
                </div>
            </ServiceRating>
            <ServiceQeustionAndAnswer>
                <div className='landing-panel'>
                    <h2 className='title'>คำถามที่พบบ่อย</h2>
                    <div className='landing-content'>
                        <div className='landing-image'>
                            <img src='/images/service-landing/question.webp' alt='คำถามที่พบบ่อย' title='คำถามที่พบบ่อย' />
                        </div>
                        <div className='question-n-answer'>
                            <QeustionBox question={'1. มีบริการในจังหวัดใดบ้าง'}> บริการเราสามารถใช้ได้ทุกจังหวัดทั่วประเทศไทย</QeustionBox>
                            <QeustionBox question={'2. จิตแพทย์กับนักจิตวิทยาคลินิก จะเลือกปรึกษากับใครดี'}>
                                <div>
                                    หากท่านมียาประจำที่ทานอยู่หรือมีอาการมาก แนะนำปรึกษาจิตแพทย์ หากท่านมีปัญหาในชีวิต รู้สึกอยากหาที่ปรึกษา
                                    อยากระบาย โดยที่ไม่มีอาการรุนแรงหรือรบกวนชีวิตประจำวัน สามารถเลือกปรึกษานักจิตวิทยาคลินิก
                                </div>
                            </QeustionBox>
                            <QeustionBox question={'3. เลือกแพทย์ได้ไหม'}>
                                ท่านสามารถเลือกแพทย์ที่ต้องการปรึกษาได้ ทั้งนี้หากแพทย์ท่านดังกล่าว
                                ไม่สามารถให้บริการในวันที่ท่านเข้ารับบริการ ท่านสามารถแจ้งให้แอดมินทราบเพื่อประสานงานเข้ารับบริการในวันถัดไป
                            </QeustionBox>
                            <QeustionBox question={'4. มีบริการส่งยาถึงบ้านไหม'}>มีบริการจัดส่งยา ท่านจะได้รับยาภายใน 1-3 วัน</QeustionBox>
                            <QeustionBox question={'5. ชำระเงินผ่านช่องทางใดได้บ้าง'}>
                                สามารถชำระด้วยบัตรเครดิต/เดบิท หรือ โอนเงินผ่านธนาคารโดยใช้ Promptpay
                            </QeustionBox>
                        </div>
                    </div>
                </div>
            </ServiceQeustionAndAnswer>
            <ServiceRelate serviceList={['telepharmacy', 'risk']} />
            <LandingLogin params={params} />
        </>
    );
}

export default MTHServiceLanding;
